import React from 'react';
import { ReactComponent as OliveBranch } from './assets/olive-branch.svg';
import { ReactComponent as RatingStar } from './assets/rating-star.svg';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

const branchClass =
  'block h-[39px] w-[19px] max-w-none hero:h-[47px] hero:w-[26.386px]';

const HomeRedesignNavRating: React.FC = () => {
  const s = useHomeRedesignStrings();

  return (
    <div className="flex min-w-0 items-center justify-center justify-self-center gap-1.5 hero:gap-[6px]">
      <div className="flex shrink-0 items-center justify-center leading-none">
        <div className="-scale-y-100 flex-none rotate-180">
          <OliveBranch aria-hidden className={branchClass} />
        </div>
      </div>
      <div className="flex flex-col items-center gap-0.5">
        <p className="text-center font-jakarta text-base font-extrabold leading-5 text-[#321730] hero:text-xl hero:leading-5">
          4.8
        </p>
        <div className="flex gap-0.5 hero:gap-[2px]">
          {Array.from({ length: 5 }).map((_, i) => (
            <RatingStar
              key={i}
              aria-hidden
              className="size-[7px] max-w-none text-[#EB42B2] hero:size-3"
            />
          ))}
        </div>
        <p className="whitespace-nowrap font-jakarta text-[11px] font-medium leading-[13px] text-[#525252] hero:text-xs hero:font-semibold hero:leading-[13px]">
          <span className="hero:hidden">{s.nav.usersShort}</span>
          <span className="hidden hero:inline">{s.nav.usersLong}</span>
        </p>
      </div>
      <div className="flex shrink-0 items-center justify-center leading-none">
        <OliveBranch aria-hidden className={branchClass} />
      </div>
    </div>
  );
};

export default HomeRedesignNavRating;
